var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.75C19 30.5825 22.9175 34.5 27.75 34.5C32.5825 34.5 36.5 30.5825 36.5 25.75C36.5 20.9175 32.5825 17 27.75 17C22.9175 17 19 20.9175 19 25.75ZM19 25.75C19 23.7798 19.6512 21.9617 20.75 20.4991V4.75M19 25.75C19 27.1944 19.35 28.557 19.9697 29.7577C18.4954 31.0031 15.0902 31.875 11.125 31.875C5.80926 31.875 1.5 30.308 1.5 28.375V4.75M20.75 4.75C20.75 6.683 16.4407 8.25 11.125 8.25C5.80926 8.25 1.5 6.683 1.5 4.75M20.75 4.75C20.75 2.817 16.4407 1.25 11.125 1.25C5.80926 1.25 1.5 2.817 1.5 4.75M1.5 20.5C1.5 22.433 5.80926 24 11.125 24C14.9558 24 18.2638 23.1862 19.8131 22.0081M20.75 12.625C20.75 14.558 16.4407 16.125 11.125 16.125C5.80926 16.125 1.5 14.558 1.5 12.625",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackLight);
export default __webpack_public_path__ + "static/media/stack_light.f61bde381de65d38923fc2d3bf7b1964.svg";
export { ForwardRef as ReactComponent };